import { Stack, Typography } from "@mui/material"
import { ReactElement } from "react"

import ExtendedTextBuilder from "./extendedTextBuilder"
import AppPaper from "../../components/surfaces/appPaper"

export type ExtendedTextBody = Array<{
    heading?: string
    subtitle?: string
    content?: string
    bullets?: string[]
    table?: {
        headers: string[]
        rows: string[]
    }
    link?: {
        text: string
        url: string
    }
}>

type PageProps = {
    title: string
    body: ExtendedTextBody
}

/**
 * ExtendedTextBuilder is a component that renders a page with a title and a
 * policy. The policy is an array of objects, each object can have a heading,
 * content, bullets, and a table. The table is an object with headers and rows.
 *
 *
 * @example
 * <PrivacyPage />
 */
const PolicyBuilder = ({ title, body }: PageProps): ReactElement => (
    <Stack gap={2}>
        <AppPaper sx={{ display: title ? undefined : "none" }}>
            <Typography variant="h4" fontWeight={500}>
                {title}
            </Typography>
        </AppPaper>
        <AppPaper>
            <ExtendedTextBuilder body={body} />
        </AppPaper>
    </Stack>
)

export default PolicyBuilder
